<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class HotelOwnLabel extends Vue {
        @Prop({required: true}) offer

        render() {
            return null
        }
    }

    export default HotelOwnLabel
</script>
